export const getCurrentUser = () => {

    try {

        const user =
            localStorage.getItem("user");

        if (!user)
            return null;

        return JSON.parse(user);

    } catch {

        return null;
    }
};

export const getUserRole = () => {

    const user = getCurrentUser();

    return user?.role || "";
};

export const getUserEmpId = () => {

    const user = getCurrentUser();

    return user?.empId || 0;
};

export const getUserBranchId = () => {

    const user = getCurrentUser();

    return user?.branchId || 0;
};

export const isAdmin = () => {

    const role =
        getUserRole().toUpperCase();

    return role === "ADMIN";
};

export const isManager = () => {

    const role =
        getUserRole().toUpperCase();

    return role === "MANAGER";
};

export const isUser = () => {

    const role =
        getUserRole().toUpperCase();

    return role === "USER";
};